/**
 * Application status
 */
import { states } from '@/bootstrap/data'

export default {
  name: 'bootstrap',
  namespaced: true,

  state: {
    fqn: null,
    model: null,

    // Loading
    status: 0,
    states: states,

    // Navigations
    navigation: null,
    burger: true,

    // i18n
    i18n: null,
    locale: null,
    locales: [],
    timezones: [],
    
    // Config (cp bootstrap)
    data: null,

    // confirm modal
    confirm: false,
  },

  getters: {
  },

  actions: {
    burger({ commit }, value) {
      commit('setBurger', value);
    },

    config({ commit }, value){
      commit('setConfig', value);
    },

    getConfig({ state }){
      return Promise.resolve( state.data );
    },

    i18n({ commit }, value){
      commit('setI18n', value);
    },

    navigation({ commit }, value){
      commit('setNavigation', value);
    },

    status({ commit }, status){
      commit('setStatus', status);
    },
  },

  mutations: {
    setBurger(state, value){
      state.burger = value === true;
    },
    
    setConfig(state, value){
      state.data = value;
    },

    setI18n(state, value){
      state.i18n = value;
      state.locale = value.locale;
      state.locales = value.locales;
    },

    setNavigation(state, value){
      state.navigation = value;
    },

    setStatus(state, value){
      state.status = value;
    },

    setConfirm(state, value) {
      state.confirm = value;
    }
  }
}
